// extracted by mini-css-extract-plugin
export default {"inputContainer":"Toggle_inputContainer__Ii1hF","toggle":"Toggle_toggle__TYWEb","slider":"Toggle_slider__iG3dV","text":"Toggle_text__gJbWl","active":"Toggle_active__8b8lW"};